import { render, staticRenderFns } from "./allIndex.vue?vue&type=template&id=221a51b8&scoped=true&"
import script from "./allIndex.vue?vue&type=script&lang=js&"
export * from "./allIndex.vue?vue&type=script&lang=js&"
import style0 from "./allIndex.vue?vue&type=style&index=0&id=221a51b8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "221a51b8",
  null
  
)

export default component.exports